export default "__VITE_ASSET__xGxI8lXz__"